var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"container"},[_c('nav',{class:{
      active: _vm.visible
    }},[_c('StickyContainer',[_c('div',{ref:"mobileScrollContainer",staticClass:"links-wrapper"},[_vm._t("default")],2)]),_c('div',{staticClass:"nav-bg",on:{"touchstart":function($event){return _vm.$emit('close')}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }